import { Injectable } from '@angular/core'

import { ReplaySubject } from 'rxjs/ReplaySubject'


@Injectable()
export class YoutubePlayerService {
  api: ReplaySubject<any>

  constructor() {
    console.log('Load YoutubePlayerService')
    this.createApi()
    this.loadYoutubeApi()
  }

  private createApi() {
    this.api = new ReplaySubject(1)
    window.onYouTubeIframeAPIReady = () => {
      this.api.next({})
    }
  }

  private loadYoutubeApi() {
    let exists = document.getElementById('yt-script-tag')
    if (!exists) {
      let tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      tag.setAttribute('id', 'yt-script-tag')
      let firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/youtube-player.ts